function getBody (documentObject) {
    if (!documentObject) return null
    if (documentObject.body) return documentObject.body
    if (typeof documentObject.querySelector !== 'function') return null
    return documentObject.querySelector('body')
}

async function requestFullscreen (documentObject) {
    const body = getBody(documentObject)
    if (!body || typeof body.requestFullscreen !== 'function') return 'unsupported'
    if (documentObject.fullscreenElement) return 'already-fullscreen'
    await body.requestFullscreen()
    return 'requested'
}

async function exitFullscreen (documentObject) {
    if (!documentObject || !documentObject.fullscreenElement) return 'not-fullscreen'
    if (typeof documentObject.exitFullscreen !== 'function') return 'unsupported'
    await documentObject.exitFullscreen()
    return 'exited'
}

async function lockKeyboard (navigatorObject) {
    const keyboard = navigatorObject && navigatorObject.keyboard
    if (!keyboard || typeof keyboard.lock !== 'function') return 'unsupported'
    await keyboard.lock()
    return 'locked'
}

function unlockKeyboard (navigatorObject) {
    const keyboard = navigatorObject && navigatorObject.keyboard
    if (!keyboard || typeof keyboard.unlock !== 'function') return 'unsupported'
    keyboard.unlock()
    return 'unlocked'
}

export async function enterCloudGameFullscreenLock ({
    documentObject = globalThis.document,
    navigatorObject = globalThis.navigator
} = {}) {
    const fullscreen = await requestFullscreen(documentObject)
    let keyboard = 'unsupported'

    try {
        keyboard = await lockKeyboard(navigatorObject)
    } catch (error) {
        keyboard = 'failed'
    }

    return { fullscreen, keyboard }
}

export async function exitCloudGameFullscreenLock ({
    documentObject = globalThis.document,
    navigatorObject = globalThis.navigator
} = {}) {
    let keyboard = 'unsupported'

    try {
        keyboard = unlockKeyboard(navigatorObject)
    } catch (error) {
        keyboard = 'failed'
    }

    const fullscreen = await exitFullscreen(documentObject)
    return { fullscreen, keyboard }
}
